<form nz-form [formGroup]="_fS.addInvestorForm">
    <div [ngClass]="!IsDrawer ? 'investor-drawer' : 'investors-modal-box'">
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }" class="ml-0 mr-0"
            [ngClass]="isAddAddressClicked ? '' : 'pt-20'">
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="firstNameError">
                        <label class="label-text required">First name</label>
                        <input class="input-group" nz-input formControlName="firstName"
                            (keypress)="_cS.checkAlphabets($event)" minlength="2" maxlength="100"
                            placeholder="Enter first name" />
                        <ng-template #firstNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter first name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">First must contain at least 2
                                characters
                            </ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter first name
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="lastNameError">
                        <label class="label-text required">Last name</label>
                        <input class="input-group" nz-input formControlName="lastName"
                            (keypress)="_cS.checkAlphabets($event)" minlength="2" maxlength="100"
                            placeholder="Enter last name" />
                        <ng-template #lastNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter last
                                name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Last name must contain at least 2
                                characters
                            </ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter last name
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12" class="pl-0">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="emailAddressError">
                        <label class="label-text required">Email address</label>
                        <input class="input-group" nz-input formControlName="emailAddress"
                            placeholder="Enter email address" />
                        <ng-template #emailAddressError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter email address
                            </ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Enter valid email address
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="12">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="phoneError">
                        <label class="label-text">Mobile number</label>
                        <input class="input-group" nz-input formControlName="phoneNumber"
                            (keypress)="_cS.checkNumbers($event)" mask="(000) 000-0000" pattern="\d{10}"
                            placeholder="Enter mobile number">
                        <ng-template #phoneError let-control>
                            <ng-container *ngIf="control.hasError('pattern')">
                                Mobile number must contain at least 10 digits
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="pl-0">
                <p class="instruction-text mb-0">Please enter the contact details for the recipient of the invoice. If
                    you are the recipient, please enter your details.</p>
            </div>
        </div>
    </div>
</form>

<div class="d-flex justify-content-end footer-box">
    <button nz-button nzType="default" (click)="handleCancel(null)" class="default-btn width-100 mr-1">Cancel</button>
    <button nz-button nzType="primary" (click)="handleOk()" class="medium-btn small-btn width-100 mr-0 "
        [nzLoading]="isAddingInvestor">Create</button>
</div>